// extracted by mini-css-extract-plugin
export default {"not-found":"NotFound_not-found__7S6sJ"};